export interface Principle {
  number: number;
  title: string;
  explanation: string;
}

// The 10 principles that guide how the FBN Entrepreneurs community shows up.
// Single source of truth - imported by CodeOfConductDialog, LandingPage, and About.
export const PRINCIPLES: Principle[] = [
  {
    number: 1,
    title: "Support before advice",
    explanation: "Listen first. Ask what would help before jumping in.",
  },
  {
    number: 2,
    title: "Everyone has a voice",
    explanation: "Make space before taking it. Invite others in.",
  },
  {
    number: 3,
    title: "Assume good intent",
    explanation: "Pause before reacting. Choose curiosity over judgment.",
  },
  {
    number: 4,
    title: "We strengthen each other",
    explanation: "Share connections, honest feedback, and encouragement freely.",
  },
  {
    number: 5,
    title: "Think in generations",
    explanation: "Play the long game. Legacy matters more than ego.",
  },
  {
    number: 6,
    title: "Share the real story",
    explanation: "Talk about what's actually hard. Honesty builds trust.",
  },
  {
    number: 7,
    title: "Energy is contagious",
    explanation: "Show up with curiosity. Leave cynicism at the door.",
  },
  {
    number: 8,
    title: "Be visible. Don't pursue.",
    explanation:
      "Share what you do openly, but never sell. This is a peer space, not a marketplace.",
  },
  {
    number: 9,
    title: "Keep entrepreneurship alive",
    explanation:
      "Pass it on. Mentor across generations and protect the builder mindset.",
  },
  {
    number: 10,
    title: "Take responsibility for the room",
    explanation:
      "If someone's new, welcome them. If the energy drifts, bring it back.",
  },
];
